import axios, { AxiosError } from 'axios';
import { useAuthStore } from './authStore';

export const api = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error: AxiosError<{ error?: { code?: string; message?: string } }>) => {
    // 401 = Token weg oder ungültig → User ausloggen.
    // ABER NICHT auf /auth/change-password: dort konnte ein 401 früher
    // bedeuten "aktuelles Passwort falsch", was den User aus dem
    // Force-Change-Modal warf und in eine Login-Schleife schickte.
    // Backend liefert dafür heute 400; die Ausnahme bleibt als
    // Sicherheitsnetz, falls in Zukunft wieder 401 missbraucht wird.
    const url = error.config?.url ?? '';
    const isPasswordChange = url.includes('/auth/change-password');
    if (error.response?.status === 401 && !isPasswordChange) {
      useAuthStore.getState().clear();
    }
    return Promise.reject(error);
  },
);

export function apiErrorMessage(err: unknown, fallback = 'Unbekannter Fehler'): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { error?: { message?: string } } | undefined;
    return data?.error?.message ?? err.message ?? fallback;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
